import React from "react";
import { useToast } from "../../../../components/ui/Toast";
import Stage3SyncPanel from "../stage3/Stage3SyncPanel";

const STAGE3_REAL = process.env.REACT_APP_STAGE3_REAL === "true";
const API = process.env.REACT_APP_API_URL;

export default function Six_Players_Stage3_Player3(props) {
  return STAGE3_REAL ? <RealStage3_Player3 {...props} /> : <PlaceholderStage3_Player3 {...props} />;
}

function PlaceholderStage3_Player3({ canAdvance, code, playerId }) {
  const toast = useToast();

  return (
    <div>
      <h2>🧪 Étape 3 — Joueur 3 - Version Bêta (placeholder)</h2>

      <p className="mt-2">
        Cette page est <strong>temporaire</strong> pour la bêta : l’énigme finale de l’étape 3 n’est pas encore intégrée.
        <br />
        Ici, on teste surtout la <strong>transition d’étape</strong> et la synchronisation entre joueurs.
      </p>

      <div className="mt-4 p-3 rounded bg-slate-900">
        <p className="font-semibold">✅ Ce qu’on veut vérifier</p>
        <ul className="list-disc ml-5 mt-2">
          <li>que tous les joueurs voient bien l’étape 3</li>
          <li>que le bouton de passage d’étape marche pour le bon joueur</li>
          <li>que l’équipe arrive bien sur la page des scores</li>
        </ul>
      </div>

      <p className="mt-4">
        <strong>Mini-consigne :</strong> préviens l’équipe que tu as le bouton de validation, puis clique sur le bouton ci-dessous.
      </p>

      {canAdvance ? (
        <button
          onClick={async () => {
            try {
              const res = await fetch(`${API}/api/game/${code}/next-stage`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ playerId }),
              });

              // optionnel : log si erreur
              if (!res.ok) {
                const body = await res.json().catch(() => null);
                console.error("next-stage failed", res.status, body);
                toast.error("Oups — impossible de passer à l’étape suivante. Réessaie dans 5s.");
              }
            } catch (e) {
              console.error("next-stage network error", e);
              toast.error("Erreur réseau — vérifie ta connexion et réessaie.");
            }
          }}
          className="mt-4 bg-indigo-600 hover:bg-indigo-500 text-white px-4 py-2 rounded"
        >
          Terminer la mission ➜
        </button>
      ) : (
        <div className="mt-4 p-3 rounded bg-amber-50 border border-amber-200">
          <p>
            ⏳ <strong>Info bêta :</strong> ce joueur n’a pas la responsabilité de changer d’étape.
            <br />
            Attends que le joueur “chef d’étape” clique, et vérifie que ton écran change bien.
          </p>
        </div>
      )}

      <p className="mt-4 text-sm text-slate-500">
        Si rien ne se passe après 10 secondes : rafraîchis la page (F5) et dis-le à l’organisateur.
      </p>
    </div>
  );
}

function RealStage3_Player3(props) {
  const { onSuccessCutsceneStart, onSuccessCutsceneEnd, onNavigateToScoreboard, centerMaxH, code, playerId, pageVariant, playerCount, pseudo, canAdvance, isCanAdvance, hintSignal, raisedCount, raisedPlayers } = props;
  return (
    <Stage3SyncPanel
      centerMaxH={centerMaxH}
      canAdvance={canAdvance}
      isCanAdvance={isCanAdvance}
      code={code}
      pseudo={pseudo}
      playerId={playerId}
      myVariant={pageVariant}
      playerCount={playerCount}
      raisedCount={raisedCount}
      raisedPlayers={raisedPlayers}
      hintSignal={hintSignal}
      onSuccessCutsceneStart={onSuccessCutsceneStart}
      onSuccessCutsceneEnd={onSuccessCutsceneEnd}
      onNavigateToScoreboard={onNavigateToScoreboard}
      onAllReady={() => {
      }}
    />
  );
}